import React, { useState, useEffect, useRef } from 'react';

const withHandleClickOutside = WrappedComponent => props => {
    const [isOpen, setIsOpen] = useState(false);
    const refNode = useRef();

    const handleClickOutside = e => {
        if (refNode.current.contains(e.target)) {
            return;
        }
        setIsOpen(false);
    }

    const onChange = e => {
        props.onChange(e);
        if (props.multiselect) {
            return;
        }
        setIsOpen(false);
    }

    const updatedProps = { ...props, refNode, isOpen, setIsOpen, onChange }

    useEffect(() => {
        if (isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        }
    }, [isOpen]);

    return <WrappedComponent {...updatedProps} />;
};

export default withHandleClickOutside;

// const BaseComponent = () => {
//     const WrappedComponent = args => {

//         const [isOpen, setIsOpen] = useState(false);
//         const refNode = useRef();

//         const handleClickOutside = e => {
//             if (refNode.current.contains(e.target)) {
//                 return;
//             }
//             setIsOpen(false);
//         }

//         const onChange = e => {
//             args.onChange(e);
//             if (args.multiselect) {
//                 return;
//             }
//             setIsOpen(false);
//         }
//         const updatedProps = { ...args, refNode, isOpen, setIsOpen, onChange }

//         useEffect(() => {
//             if (isOpen) {
//                 document.addEventListener("mousedown", handleClickOutside);
//             } else {
//                 document.removeEventListener("mousedown", handleClickOutside);
//             }

//             return () => {
//                 document.removeEventListener("mousedown", handleClickOutside);
//             }
//         }, [isOpen]);

//         return BaseComponent(updatedProps);
//     }

//     return WrappedComponent;
// };

// export default BaseComponent;